/**
 * Función que crea una capa de tipo WMTS a
 * @returns {TileLayer} Capa de tipo WMTS
 */

import WMTS from 'ol/source/WMTS.js';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';
import { get as getProjection } from 'ol/proj.js';
import { getTopLeft, getWidth } from 'ol/extent.js';
import TileLayer from 'ol/layer/Tile'

export function layerWMTS(props) {
    const {
        name,
        title,
        image,
        type,
        visible = false,
        url,
        attributions = false,
        opacity = 1.0,
        queryable = true,
        tematica = false,
        group = null,
        matrixSet,
        minZoom = null,
        maxZoom = null,
      } = props;

    const projection = getProjection('EPSG:3857');
    const projectionExtent = projection.getExtent();
    const size = getWidth(projectionExtent) / 256;

    const resolutions = new Array(14);
    const matrixIds = new Array(14);

    for (let z = 0; z < 14; ++z) {
      resolutions[z] = size / Math.pow(2, z);
      matrixIds[z] = z;
    }

    // Build layer options
    const layerOptions = {
      title,
      image,
      type,
      visible,
      queryable,
      opacity,
      tematica,
      group,
    };

    // Only add minZoom/maxZoom if they are valid numbers
    if (minZoom !== null && minZoom !== undefined && !isNaN(Number(minZoom))) {
      layerOptions.minZoom = Number(minZoom);
    }
    if (maxZoom !== null && maxZoom !== undefined && !isNaN(Number(maxZoom))) {
      layerOptions.maxZoom = Number(maxZoom);
    }

    layerOptions.source = new WMTS({
        url,
        attributions,
        layer: name,
        matrixSet,
        format: 'image/jpeg',
        crossOrigin: 'anonymous',
        tileGrid: new WMTSTileGrid({
          origin: getTopLeft(projectionExtent),
          resolutions: resolutions,
          matrixIds: matrixIds,
        }),
        style: 'default',
        wrapX: true,
        VERSION: '1.0.0'
      });

    const wmtsLayer = new TileLayer(layerOptions);
    return wmtsLayer;
  }